module.exports = __webpack_public_path__ + "img/intropage-lifestyle-data-icon.04182284.svg";